import { put, takeLatest, call, all } from 'redux-saga/effects';
import ApiService from 'services/ApiService';
import {
  fetchOrgAddressTaxRateInProgress,
  fetchOrgAddressTaxRateCompleted,
  fetchOrgAddressTaxRateFailed,
  fetchPriceInProgress,
  fetchPriceCompleted,
  fetchPriceFailed,
  OnBoardingActionTypes,
  fetchRenewalPriceInProgress,
  fetchRenewalPriceCompleted,
  fetchRenewalPriceFailed,
} from './actions';
import { extractError } from '../../utils/functions';

function* onFetchOrgAddressTaxRateInProgress(action) {
  try {
    yield put(fetchOrgAddressTaxRateInProgress());
    const res = yield call(
      ApiService.fetchOrgAddressTaxRate,
      action.payload.orgAddress,
      action.payload.amount,
      action.payload.organizationId,
      action.payload.step,
    );
    yield put(fetchOrgAddressTaxRateCompleted(res.data));
  } catch (error) {
    yield put(fetchOrgAddressTaxRateFailed(extractError(error.data)));
  }
}

function* onFetchPriceInProgress(action) {
  try {
    yield put(fetchPriceInProgress());
    const res = yield call(ApiService.fetchPrice, action.payload.seats, action.payload.months);
    yield put(fetchPriceCompleted(res.data));
  } catch (error) {
    yield put(fetchPriceFailed(extractError(error.data)));
  }
}

function* onFetchRenewalPriceInProgress(action) {
  try {
    yield put(fetchRenewalPriceInProgress());
    const res = yield call(ApiService.fetchRenewalPrice, action.payload.seats);
    yield put(fetchRenewalPriceCompleted(res.data));
  } catch (error) {
    yield put(fetchRenewalPriceFailed(extractError(error.data)));
  }
}

export default function* watch() {
  yield all([
    takeLatest(OnBoardingActionTypes.FETCH_ORG_ADDRESS_TAX_RATE_REQUEST, onFetchOrgAddressTaxRateInProgress),
    takeLatest(OnBoardingActionTypes.FETCH_PRICE_REQUEST, onFetchPriceInProgress),
    takeLatest(OnBoardingActionTypes.FETCH_RENEWAL_PRICE_REQUEST, onFetchRenewalPriceInProgress),
  ]);
}
